import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ArchiveMemberMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ArchiveMemberMutation = { __typename?: 'Mutation', archiveOrganisationMember: { __typename?: 'OrganisationMemberUser', id: string, archivedAt?: number | null } };


export const ArchiveMemberDocument = gql`
    mutation archiveMember($id: ID!) {
  archiveOrganisationMember(id: $id) {
    id
    archivedAt
  }
}
    `;
export type ArchiveMemberMutationFn = Apollo.MutationFunction<ArchiveMemberMutation, ArchiveMemberMutationVariables>;

/**
 * __useArchiveMemberMutation__
 *
 * To run a mutation, you first call `useArchiveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMemberMutation, { data, loading, error }] = useArchiveMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveMemberMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMemberMutation, ArchiveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMemberMutation, ArchiveMemberMutationVariables>(ArchiveMemberDocument, options);
      }
export type ArchiveMemberMutationHookResult = ReturnType<typeof useArchiveMemberMutation>;
export type ArchiveMemberMutationResult = Apollo.MutationResult<ArchiveMemberMutation>;
export type ArchiveMemberMutationOptions = Apollo.BaseMutationOptions<ArchiveMemberMutation, ArchiveMemberMutationVariables>;